export default __webpack_public_path__ + "locales/fi/DataReassignmentDialog.json?hash=3533466909c6ae062cb16ce9618781c1";